<template>
  <so-no-input v-model="value" @blur="onBlur" />
</template>

<script>
import Vue from 'vue'
import soNoInput from '@/components/Cargo/Job/soNoInput'
import TableKeyboardNav from '@/mixin/TableKeyboardNav'

export default Vue.extend({
  name: 'CargoAgGridSoNoInputEditor',
  components: { soNoInput },
  mixins: [TableKeyboardNav],
  data() {
    return {
      value: ''
    }
  },
  created() {
    this.value = this.params.value
  },
  methods: {
    getValue() {
      return this.value
    },
    onBlur() {
      this.params.api.stopEditing()
    }
  }
})
</script>
